// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__3YqF3","wrap":"Layout_wrap__2pUgn","content":"Layout_content__250w2"};